import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DataQueryService } from '../data-query.service';
import { DataQueryPreferences } from '../../../shared-components/user-preferences/data-query-preferences.model';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { DataQueryField } from '../models/data-query-field.model';
import { DataQuery } from '../models/data-query.model';
import { LoginService } from '../../../shared-modules/login/login.service';
import { SecurityService } from '../../../shared-components/security/security.service';

@AutoUnsubscribe()
@Component({
    selector: 'data-query-field-label',
    templateUrl: './data-query-field-label.component.html',
    styleUrls: ['./data-query-field-label.component.css']
})
export class DataQueryFieldLabelComponent implements OnInit, OnDestroy {

    // Properties
    preferences: DataQueryPreferences;
    currentQuery: DataQuery;
    V10: boolean;
    @Input() field: DataQueryField;
    @Input() editable = false;
    @Input() fieldId = 'columnNameField';
    @Input() hideEditableIcon = false;
    enableMassUpdate = false;

    // Class Functions
    constructor(
        private dataQueryService: DataQueryService,
        private loginService: LoginService,
        private securityService: SecurityService
    ) { }

    // Event Functions
    ngOnInit() {
        // POST: performs initialization
        this.V10 = this.loginService.LoginSettings.V10;
        this.enableMassUpdate = this.dataQueryService.enableMassUpdate;

        // Syncing data
        this.dataQueryService.observablePreferencesStream$.subscribe(preferences => {
            this.preferences = preferences;
        });
        this.dataQueryService.observableCurrentQueryStream$.subscribe(currentQuery => {
            this.currentQuery = currentQuery;
        });
    }

    ngOnDestroy() {
        // NOTE: implemented for @AutoUnsubscribe
    }

    // Methods
    ambiguous(field: DataQueryField): boolean {
        let ambiguous = false;
        for (let i = 0; i < this.currentQuery.reportFields.length; i++) {
            if (this.currentQuery.reportFields[i].DisplayName == field.DisplayName && this.currentQuery.reportFields[i] != field) {
                ambiguous = true;
                break;
            }
        }
        return ambiguous;
    }

    checkDisabledField(): boolean {
        return this.dataQueryService.checkDisabledField(this.field);
    }

    checkEditableField(): boolean {
        return this.dataQueryService.checkEditableField(this.field);
    }
}
